<template>
  <v-dialog v-model="dialog" persistent max-width="50%" v-if="verbale">
    <v-card>
      <v-card-title>Verbale firmato</v-card-title>
      <v-card-text>
        <v-flex d-flex>
          <v-file-input
            outlined
            dense
            v-model="file"
            accept="application/pdf"
            truncate-length="100"
          ></v-file-input>
          <v-btn :disabled="!verbale.attachment" @click="downloadVerbale" icon>
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="close">Chiudi</v-btn>
        <v-btn color="success" text @click="save" :disabled="!file"
          >Salva</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*eslint-disable */
import mixin from "../mixin/MixingCommonComp";

export default {
  mixins: [mixin],
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      verbale: null,
      file: null,
    };
  },
  methods: {
    open(verbale) {
      this.verbale = verbale;
      this.file = null;
      this.dialog = true;

      if (verbale.attachment) {
        let contentType = verbale.attachment.contentType;
        let data = new Blob(
          [
            Uint8Array.from(atob(verbale.attachment.data), (c) =>
              c.charCodeAt(0)
            ),
          ],
          { contentType }
        );
        this.file = new File([data], verbale.attachment.name, {
          type: verbale.attachment.contentType,
        });
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    close() {
      this.dialog = false;
      this.resolve();
    },
    save() {
      if (!this.file) {
        return;
      }

      if (this.file.type != "application/pdf") {
        this.showErrorDialog("Estensione non supportata");
        return;
      }

      var reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = async () => {
        let fileContent = reader.result;
        fileContent = fileContent.split(",")[1];

        let response = await this.uploadVerbaleFirmato(fileContent);
        console.log(response);
        if (response.data.result == "OK") {
          this.dialog = false;
          this.resolve({
            contentType: "application/pdf",
            data: fileContent,
            name: this.verbale.nomeVerbale.replaceAll("/", "_") + ".pdf",
          });
        } else {
          this.showErrorDialog(response.data.message);
        }
      };
    },
    downloadVerbale() {
      if (!this.verbale || !this.verbale.attachment) {
        return;
      }

      let linkSource =
        "data:application/pdf;base64," + this.verbale.attachment.data;
      let downloadLink = document.createElement("a");
      let fileName = this.verbale.nomeVerbale + ".pdf";

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },
    async uploadVerbaleFirmato(fileContent) {
      let parameters = {};
      parameters.data = {
        id: this.verbale.fct_ver_id,
        tipoVerbale: this.verbale.tipoVerbale,
        attachments: [
          {
            filename: this.verbale.nomeVerbale.replaceAll("/", "_") + ".pdf",
            fileContent: fileContent,
          },
        ],
      };
      parameters.idempiereRestPath = "vecos/uploadVerbaleFirmato";

      return await this.$store.dispatch("callIdempiereRest", parameters);
    },
  },
};
</script>

<style>
</style>